var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"navbar-item",class:_vm.sortable ? '' : 'disabled',attrs:{"role":"button"},on:{"click":_vm.changeSort}},[_vm._v(" "+_vm._s(_vm.header)+" "),(_vm.sortable)?[(_vm.pagination.sortBy === _vm.field)?_c('b-icon',{attrs:{"icon":_vm.sortDirectionComputed}}):_c('b-icon',{attrs:{"type":"is-white","icon":"chevron-down"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }